import i18n from "@/common/i18n";
import Layout from '@/layout/index';
const router = [{
  path: '/setting',
  component: Layout,
  redirect: '/setting/chat',
  meta: {
    auth: true,
    title: `${i18n.t("lang.k_019001")}`,
    name: 'settingMgr',
    icon: 'saasicon_Settings_img'
  },
  children: [
    // {
    //   path: 'info',
    //   component: () => import('@/views/SettingModule/setting.vue'),
    //   meta: { auth: true, title: '开发设置', name: 'settingInfo', activeMenu: '/setting/info' }
    // }, // 开发设置 - 总览页隐藏
    {
      path: 'chat',
      component: () => import('@/views/SettingModule/chat'),
      name: 'chat',
      meta: {
        auth: true,
        title: `${i18n.t("lang.k_019002")}`,
        name: 'chatMgr',
        activeMenu: '/setting/chat'
      }
    }, {
      path: 'safeScreen',
      component: () => import('@/views/LiveModule/Brands/safeScreenSet'),
      name: 'safeScreen',
      meta: {
        auth: true,
        title: `${i18n.t("lang.k_019003")}`,
        name: 'safeScreen',
        activeMenu: '/setting/safeScreen',
        auth_key: 'player_config'
      }
    }, {
      path: '/setting/dev',
      component: () => import('@/views/SettingModule/setting'),
      name: 'dev',
      meta: {
        title: `${i18n.t("lang.k_019004")}`,
        icon: '',
        name: 'devMgr',
        activeMenu: '/setting/dev'
      }
    }, {
      path: 'logo',
      component: () => import('@/views/SettingModule/logo'),
      name: 'logo',
      meta: {
        auth: true,
        title: `${i18n.t("lang.k_019005")}`,
        name: 'logoMgr',
        activeMenu: '/setting/logo'
      }
    }, {
      path: 'function',
      component: () => import('@/views/LiveModule/planFunction'),
      name: 'function',
      meta: {
        auth: true,
        title: `${i18n.t("lang.k_019006")}`,
        name: 'functionMgr',
        activeMenu: '/setting/function'
      }
    }, {
      path: 'brand',
      component: () => import('@/views/SettingModule/setLiving'),
      name: 'brand',
      meta: {
        auth: true,
        title: `${i18n.t("lang.k_019007")}`,
        name: 'livingMgr',
        activeMenu: '/setting/brand'
      }
    }, {
      path: 'protocol',
      component: () => import('@/views/SettingModule/protocol'),
      name: 'protocol',
      meta: {
        auth: true,
        title: `${i18n.t("lang.k_019008")}`,
        name: 'protocolMgr',
        activeMenu: '/setting/protocol',
        auth_key: 'watch.viewing_protocol',
        appCls: 'std-app'
      }
    }, {
      path: 'player',
      component: () => import('@/views/LiveModule/Brands/playerSet'),
      name: 'player',
      meta: {
        auth: true,
        title: `${i18n.t("lang.k_019009")}`,
        name: 'playerMgr',
        activeMenu: '/setting/player',
        auth_key: 'player_config'
      }
    }, {
      path: 'tagset',
      component: () => import('@/views/SettingModule/tagSet/index.vue'),
      name: 'tagset',
      meta: {
        auth: true,
        title: `${i18n.t("lang.k_019010")}`,
        name: 'tagset',
        activeMenu: '/setting/tagset'
      }
    }, {
      path: '/dev/add',
      component: () => import('@/views/SettingModule/Development/appInfo'),
      meta: {
        auth: true,
        title: `${i18n.t("lang.k_019011")}`,
        name: 'devAdd',
        activeMenu: '/setting/dev',
        action: 'add'
      },
      hidden: true
    }, {
      path: '/dev/:appId(\\d+)',
      component: () => import('@/views/SettingModule/Development/appInfo'),
      meta: {
        auth: true,
        title: `${i18n.t("lang.k_019012")}`,
        name: 'devModify',
        activeMenu: '/setting/dev',
        action: 'detail'
      },
      hidden: true
    }, {
      path: '/dev/callback',
      component: () => import('@/views/SettingModule/Development/callback'),
      meta: {
        auth: true,
        title: `${i18n.t("lang.k_019013")}`,
        name: 'devCallback',
        activeMenu: '/setting/dev'
      },
      hidden: true
    }, {
      path: 'logo/:str(\\d+)',
      component: () => import('@/views/SettingModule/logo'),
      meta: {
        auth: true,
        title: `${i18n.t("lang.k_019005")}`,
        name: 'logoSetting',
        activeMenu: '/setting/logo'
      },
      hidden: true
    }, {
      path: 'viewer',
      component: () => import('@/views/MaterialModule/viewer'),
      meta: {
        auth: true,
        title: `${i18n.t("lang.k_019014")}`,
        name: 'viewerMgr',
        auth_key: 'white_list'
      }
    }, {
      path: 'channel',
      component: () => import('@/views/MaterialModule/channel'),
      meta: {
        auth: true,
        title: `${i18n.t("lang.k_019015")}`,
        name: 'channelSetting',
        auth_key: 'watch.channel'
      }
    }, {
      path: 'commonParams',
      component: () => import('@/views/MaterialModule/commonParams'),
      meta: {
        auth: true,
        title: `${i18n.t("lang.k_019016")}`,
        name: 'commonParams'
      }
    }, {
      path: 'officialAccAuth',
      component: () => import('@/views/MaterialModule/officialAccAuth'),
      meta: {
        auth: true,
        title: `${i18n.t("lang.k_019017")}`,
        name: 'officialAccAuth'
      }
    }, {
      path: 'webinarBusinessField',
      component: () => import('@/views/SettingModule/webinarBusinessField'),
      meta: {
        auth: true,
        title: `${i18n.t("lang.k_019018")}`,
        name: 'webinarBusinessField',
        auth_key: 'webinar_custom_fields'
      }
    }, {
      path: 'setVipTag',
      component: () => import('@/views/MaterialModule/setVipTag'),
      meta: {
        auth: true,
        title: `${i18n.t("lang.k_019019")}`,
        name: 'setVipTag'
      }
    }]
}];
export default router;